import { roleHelpers } from '@/services/utils';
angular.module('leanlaw').controller('ClientsCtrl', ['$scope', '$http', '$window', 'matterFilterService', 'leanLawAuth', 'alerts', 'userService', '$state', 'tippy', '$timeout', 'exportJson', function ($scope, $http, $window, matterFilterService, leanLawAuth, alerts, userService, $state, tippy, $timeout, exportJson) {
  $scope.vm = {
    me: undefined
  };
  $scope.state = $state;
  $scope.currentPage = 1;
  $scope._ = _;
  $scope.loading = true;
  $scope.domain = `${leanLawAuth.domain}/v1`;
  $scope.matterFilter = matterFilterService.state;
  $scope.filter = {
    scopeAccount: null,
    originating: $scope.matterFilter.originating || false,
    primary: $scope.matterFilter.primary,
    involved: true,
    orphans: false,
    reviewer: false,
    search: '',
    quickBooksStatuses: null,
    checkQuickbooks: false,
    qbConnectionType: 'any',
    customFields: {} // { fieldId: optionId }
  };
  $scope.customFieldFilters = [];
  $scope.paging = {
    currentPage: 1,
    itemsPerPage: 20,
    orderBy: 'clientId',
    sortAscending: true,
    itemCount: 0
  };
  $scope.clients = [];
  $scope.clientsToExport = [];
  $scope.sort = 'client.name';
  $scope.showConnectionStatuse = false;
  $scope.validating = false;
  $scope.export = exportClient;
  $scope.QBOClients = [];
  $scope.accounts = [];
  $scope.accountsLoaded = false;
  $scope.loadPagedClients = loadPagedClients;
  $scope.showReviewer = false;
  $scope.pageOptions = [{
    text: 10,
    value: 10
  }, {
    text: 20,
    value: 20
  }, {
    text: 50,
    value: 50
  }];
  $scope.filterOrphans = false;
  $scope.clientCreatedCallback = function (client) {
    $scope.go('.client', {
      id: client.id
    });
  };
  $scope.print = function () {
    window.print();
  };
  $scope.pageTable = function (newPageNumber) {
    $scope.paging.currentPage = newPageNumber;
    loadPagedClients();
  };
  loadPage();
  async function loadPage() {
    const me = await userService.me();
    $scope.vm.me = me;
    $scope.integration = me.company.integration;
    $scope.filterOrphans = $scope.me.role !== 'timekeeper';
    $scope.showReviewer = me.company.settings.workflow.reviewer;
    $scope.selectedAccount = {
      id: me.id
    };
    // Copied from timeentries.ctrl.js
    if (!roleHelpers.isOperatorOrAccountantRole(me.role)) {
      $scope.filter.account = me;
    }
    if (me.settings.selectedAccount) {
      $scope.selectedAccount = {
        id: me.settings.selectedAccount.id
      };
    }
    if (me.features.customFieldFilters) {
      loadCustomFields();
    }
    loadAccounts();
  }
  function loadCustomFields() {
    const path = `${$scope.domain}/customfields`;
    $http.get(path).then(response => {
      const fields = response.data || [];
      // Filter for client dropdown/enum fields that are active
      $scope.customFieldFilters = fields.customFields.filter(f => f.entity == 'client' && f.type === 'enum' && f.active);
    }).catch(err => {
      console.error('Error loading custom fields:', err);
    });
  }
  $scope.customFieldChanged = function () {
    loadPagedClients();
  };
  function loadAccounts() {
    $scope.accountsLoaded = false;
    userService.list().then(accounts => {
      let scopeAccountIdToFind = null;
      if (!roleHelpers.isOperatorOrAccountantRole($scope.vm.me.role)) {
        scopeAccountIdToFind = $scope.matterFilter.scopeAccount ? $scope.matterFilter.scopeAccount.id : $scope.vm.me.id;
      } else if ($scope.matterFilter.scopeAccount) {
        scopeAccountIdToFind = $scope.matterFilter.scopeAccount.id;
      }
      $scope.accounts = accounts;
      $scope.filter.scopeAccount = scopeAccountIdToFind ? $scope.accounts.find(x => x.id === scopeAccountIdToFind) : null;
      $scope.accountsLoaded = true;
      $scope.filterLoaded();
      loadPagedClients();
    }).catch(ex => {
      console.log(ex);
    });
  }
  function loadPagedClients() {
    $scope.loading = true;
    updateMatterFilter();
    const query = buildQuery(false);
    fetchPagedClients(query).then(response => {
      $scope.clientReferences = false;
      const clients = response.data.items;
      $scope.paging.itemCount = response.data.count;
      $scope.clientReferences = clients.some(x => x.reference);
      $scope.clients = clients;
      if ($scope.filter.checkQuickbooks) {
        $scope.QBOClients = $scope.clients;
        $scope.showConnectionStatuse = true;
        $scope.validating = false;
      } else {
        $scope.QBOClients = [];
      }
      $scope.loading = false;
      $timeout(() => {
        tippy('.tippy-avatar');
      }, 200);
    });
  }
  $scope.scopeChange = function (prop) {
    loadPagedClients();
  };
  function fetchPagedClients(query) {
    const path = `${$scope.domain}/clients/table`;
    return $http.get(path, {
      params: query
    });
  }
  function buildQuery(forExport) {
    const limit = forExport ? $scope.paging.itemCount : $scope.paging.itemsPerPage;
    const scopeAccount = $scope.filter.scopeAccount ? $scope.filter.scopeAccount.id : null;
    if (scopeAccount) {
      $scope.filter.involved = true;
    } else {
      $scope.filter.involved = false;
      $scope.filter.originating = false;
      $scope.filter.primary = false;
    }
    const query = {
      limit,
      offset: ($scope.paging.currentPage - 1) * $scope.paging.itemsPerPage,
      sortAscending: $scope.paging.sortAscending,
      orderBy: $scope.paging.orderBy,
      scopeAccount,
      originating: $scope.filter.originating,
      involved: $scope.filter.involved,
      primary: $scope.filter.primary,
      reviewer: $scope.filter.reviewer,
      showOrphans: $scope.filter.orphans,
      search: $scope.filter.search,
      checkQuickbooks: $scope.filter.checkQuickbooks,
      qbConnectionType: $scope.filter.qbConnectionType
    };

    // Add custom field filters
    const customFieldEntries = Object.entries($scope.filter.customFields || {});
    customFieldEntries.forEach(([fieldId, optionId], index) => {
      // Skip if empty string, null, or undefined (deselected)
      if (optionId && optionId !== '') {
        query[`clientcustomfield[${index}].fieldid`] = fieldId;
        // Only include optionid if not filtering for "Not assigned"
        if (optionId !== 'NOT_ASSIGNED') {
          query[`clientcustomfield[${index}].optionid`] = optionId;
        }
      }
    });
    return query;
  }
  $scope.changeSort = function (sortField) {
    if ($scope.paging.orderBy === sortField) {
      $scope.paging.sortAscending = !$scope.paging.sortAscending;
    } else {
      $scope.paging.orderBy = sortField;
      $scope.paging.sortAscending = true;
    }
    loadPagedClients();
  };
  $scope.delete = client => {
    bootbox.confirm(`Should the client "${client.label}" be removed from the system? It doesn't have any matters or other data associated with it, but it cannot be undone.`, result => {
      if (result) {
        const path = `${$scope.domain}/clients/${client.id}`;
        $http.delete(path).then(() => {
          alerts.success(`The client "${client.label}" was removed`);
          $scope.loadPagedClients();
        }).catch(err => {
          alerts.error(err);
        });
      }
    });
  };
  function exportClient() {
    const query = buildQuery(true);
    fetchPagedClients(query).then(response => {
      $scope.clientsToExport = response.data.items;
      function makeRow(client) {
        return {
          'Client Id': client.reference,
          Client: client.name,
          Company: client.companyName,
          Contact: client.contactName,
          Phone: client.phone,
          Responsible: client.primary.join(' ')
        };
      }
      const items = [];
      $scope.clientsToExport.forEach(t => items.push(makeRow(t)));
      exportJson.downloadCsv(items, 'Clients');
    });
  }
  $scope.showConnectionStatusesFilter = function () {
    $scope.validating = true;
    $scope.filter.checkQuickbooks = true;
    loadPagedClients();
  };
  $scope.changeConnectionStatuses = function () {
    $scope.filter.qbConnectionType = $scope.filter.quickBooksStatuses ? $scope.filter.quickBooksStatuses : 'any';
    loadPagedClients();
  };
  $scope.filterLoaded = function () {
    $scope.filter.loaded = true;
  };
  $scope.showClient = clientId => {
    const path = `${$scope.domain}/clients/${clientId}?matters=include`;
    $http.get(path).then(response => {
      const client = response.data;
      if (!client.matters) {
        // orphan, don't go to client because things will break
        alerts.warning(`Please create a ${$scope.vm.me.terms.matter} for the client to start using it in the system`);
        return;
      }
      $state.go('.client', {
        id: client.id
      });
      $scope.loading = false;
      $timeout(() => {
        tippy('.tippy-avatar');
      }, 200);
    });
  };
  $scope.openAccounting = client => {
    const url = `${$scope.vm.me.configuration.quickbooks}/app/customerdetail?nameId=${client.quickBooksId}`;
    $window.open(url);
  };
  $scope.navigateToCreateClient = () => {
    const targetState = ($scope.vm.me.features?.timeEntriesTab ?? false) && ($scope.vm.me.settings?.enableNewTimeEntry ?? false) ? 'clients.client2' : 'clients.newMatter.client';
    $state.go(targetState, {
      methodOverride: 'client page'
    });
  };
  function updateMatterFilter() {
    $scope.matterFilter.scopeAccount = $scope.filter.scopeAccount;
    $scope.matterFilter.primary = $scope.filter.primary;
    $scope.matterFilter.originating = $scope.filter.originating;
  }
}]);